import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ProprieteState } from '../../propriete.state';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { map, mergeMap } from 'rxjs/operators';
import { ProprieteHelper } from '../../modeles/ProprieteHelper';
import { SetCurrentCodePage } from '../../../shared/navigation.state';
import { CapaciteModel } from '../../../tool-capacite/latest/modeles/capacite.model';
import { ProprieteModele } from '../../modeles/proprieteModel';
import { MPM_PROPRIETE_PHOTO_ENABLED } from '../../../../configs/toggles.config';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss'],
  standalone: false
})
export class PropertyDetailsComponent implements OnInit {
  selectPropertyById$: Observable<ProprieteModele>;
  selectedProperty$: Observable<ProprieteModele>;

  capacite$: Observable<CapaciteModel> = this._toolCapaciteService.donneesCapacite$;
  capacite: CapaciteModel;

  totalDepenses$: Observable<number> = this._toolCapaciteService.totalDepenses$;
  totalDepenses: number;

  totalEngagements$: Observable<number> = this._toolCapaciteService.totalEngagements$;
  totalEngagements: number;

  MPM_PROPRIETE_PHOTO_ENABLED = MPM_PROPRIETE_PHOTO_ENABLED;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _store: Store,
    private readonly _route: Router,
    private readonly _toolCapaciteService: ToolCapaciteService
  ) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodePage('detail'));

    this.selectedProperty$ = this._activatedRoute.params.pipe(
      map(route => route.id),
      mergeMap(id => this._store.select(ProprieteState.selectPropertyById).pipe(map(findFn => findFn(id))))
    );

    this.capacite$.subscribe(data => {
      this.capacite = data;
    });

    this.totalDepenses$.subscribe(data => {
      this.totalDepenses = data;
    });

    this.totalEngagements$.subscribe(data => {
      this.totalEngagements = data;
    });
  }

  navigateBackHome(): void {
    this._route.navigate(['/']);
  }

  getProperty(propriete: ProprieteModele): ProprieteHelper {
    return new ProprieteHelper(propriete);
  }

  createProperty(): void {
    this._route.navigate(['propriete/creation-propriete']);
  }

  get totalDepensesSelonIndicateur() {
    if (this.capacite.indicateurMontantTotalDepenses === 'O') {
      return this.capacite.montantTotalDepenses;
    }
    return this.totalDepenses;
  }

  private getIndicateur(propriete: ProprieteModele): string {
    return propriete.analyseEcartPrequalification && propriete.analyseEcartPrequalification.indicateurRisque
      ? propriete.analyseEcartPrequalification.indicateurRisque
      : null;
  }

  hasNoDepensesDettes(propriete: ProprieteModele) {
    const indicateur = this.getIndicateur(propriete);
    return (
      (indicateur === 'BAS' || indicateur === 'MOYEN') &&
      (this.totalEngagements === 0 || this.totalDepensesSelonIndicateur === 0)
    );
  }

  isIndicateurRisqueMoyenHaut(propriete: ProprieteModele) {
    const indicateur = this.getIndicateur(propriete);
    return indicateur === 'MOYEN' || indicateur === 'HAUT';
  }
}
